import { useMemo } from "react";
import { useAppSelector } from "@/core/store";
import { createAppTheme } from "./muiTheme";

// Dynamic Theme Hook - integrates Redux theme state with MUI
export const useDynamicTheme = () => {
  const { theme, customColors } = useAppSelector((state) => state.app);

  // Handle theme mode changes via useColorScheme
  const mode = useMemo(() => {
    switch (theme) {
      case "auto":
        return "light";
      case "custom":
        return "light"; // Default custom theme to light mode
      default:
        return theme;
    }
  }, [theme]);

  // Only recreate theme when custom colors change
  return useMemo(() => {
    const palette = createAppTheme(mode, customColors);
    console.log("palette", palette);
    return palette;
  }, [customColors, mode]);
};
